// Français de France. Original English keys and interpolation names are preserved.
// UI copy: vous for the adult; spoken child-facing phrases live in the situation data.
export const fr: Record<string, string> = {
  "General profile": "Profil général",
  "Loading...": "Chargement…",
  "Obedience Code": "La Méthode des 3 Phrases",
  "Put the app on your phone": "Gardez la méthode à portée de main",
  "One tap from your home screen, like any other app. It takes about a minute.": "Retrouvez votre espace depuis l’écran d’accueil de votre téléphone. L’ajout prend environ une minute.",
  "Show me how": "Voir les étapes",
  "Not now, go to the app": "Continuer sans l’ajouter",
  "You're All Set! 🎉": "Tout est prêt ! 🎉",
  "The app is installed. Let's continue.": "Votre espace est ajouté. Continuons.",
  "Redirecting...": "Redirection…",
  "Not Detected Yet": "Ajout pas encore détecté",
  "Installation can take a moment. Try again or go back.": "L’ajout peut prendre un instant. Réessayez ou revenez aux étapes.",
  "After installing, ": "Après l’ajout, ",
  "close this browser": "fermez ce navigateur",
  " and ": " et ",
  "open from home screen": "ouvrez votre espace depuis l’écran d’accueil",
  "Check Again": "Vérifier à nouveau",
  "Back to Instructions": "Revoir les étapes",
  "Skip anyway": "Continuer sans l’ajouter",
  "Theme saved locally. Will sync to cloud when connection restores.": "Votre thème est enregistré sur cet appareil. La synchronisation a échoué.",
  "Light & Clean": "Clair et lumineux",
  "Perfect for daytime use": "Agréable en journée",
  "Dark & Focused": "Sombre et doux",
  "Easy on the eyes": "Confortable pour les yeux",
  "Choose Your Experience": "Choisissez votre ambiance",
  "Select the theme that feels right for you": "Choisissez le thème qui vous convient",
  "☀️ Bright": "☀️ Lumineux",
  "🌙 Calm": "🌙 Apaisant",
  "You can change this anytime in settings": "Vous pourrez changer de thème dans les réglages",
  "Shared access ended": "L’accès partagé a pris fin",
  "Refunded purchase": "Achat remboursé",
  "Chargeback": "Paiement contesté",
  "Policy violation": "Non-respect des conditions",
  "Shared access ended — options to continue": "Fin de l’accès partagé : comment continuer",
  "Account access — review request": "Accès à mon compte : demande de vérification",
  "unknown email": "adresse e-mail non renseignée",
  "Account access blocked": "Accès au compte bloqué",
  "The person who shared access with you had their purchase refunded, so the shared access ended. If you'd like your own access to continue using the program, reach out and we'll help you get set up.": "L’achat de la personne qui partageait son accès avec vous a été remboursé. Cet accès a donc pris fin. Écrivez-nous pour connaître les possibilités de continuer.",
  "Your account is currently not available. This usually happens after a refund or a chargeback on the original purchase. If you believe this is a mistake, our team is here to help.": "Votre compte est actuellement inaccessible. Cela peut arriver après un remboursement ou une contestation du paiement. Si vous pensez qu’il s’agit d’une erreur, écrivez-nous.",
  "Account": "Compte",
  "Reason": "Motif",
  "Email support": "Écrire à l’assistance",
  "Message us on WhatsApp": "Nous écrire sur WhatsApp",
  "Replies usually within 24 hours.": "Réponse généralement sous 24 heures.",
  "Hi,\n\nMy account ({email}) was blocked because the person who shared access with me had their purchase refunded. I'd like to know my options to continue using the program.\n\nThanks.": "Bonjour,\n\nMon compte ({email}) a été bloqué après le remboursement de l’achat de la personne qui partageait son accès avec moi. Je souhaite connaître les possibilités de continuer.\n\nMerci.",
  "Hi,\n\nMy account ({email}) has been blocked and I would like to request a review.\n\nOrder / reason context:\n\nThanks.": "Bonjour,\n\nMon compte ({email}) est bloqué. Pourriez-vous vérifier mon accès ?\n\nRéférence de commande et précisions :\n\nMerci.",
  "Dashboard": "Accueil",
  "The 3 Magic Words": "Les 3 phrases",
  "Guides": "Guides",
  "Oops! Page not found": "Cette page est introuvable",
  "The page you're looking for doesn't exist or has been moved.": "La page que vous cherchez n’existe pas ou a été déplacée.",
  "Go Back": "Retour",
  "Back to Home": "Revenir à l’accueil",
  "💡 Pro tip: You can always find your way home by clicking the logo": "💡 Vous pouvez revenir à l’accueil en touchant le logo",
  "Back": "Retour",
  "Three short phrases, said in order. Here they are for {context}.": "Trois phrases courtes, dans cet ordre. Voici quoi dire pour {context}.",
  "Choose a situation": "Choisir une situation",
  "The 3 phrases for {situation}": "Les 3 phrases : {situation}",
  "Use the things your child is actually playing with. Keep the same order.": "Parlez de ce avec quoi votre enfant joue vraiment. Gardez le même ordre.",
  "Try again": "Réessayer",
  "Save this card": "Enregistrer cette carte",
  "Preparing your card...": "Préparation de votre carte…",
  "We couldn’t prepare your card. Please try again.": "Nous n’avons pas pu préparer votre carte. Réessayez.",
  "Keep it on your phone or print it.": "Gardez-la sur votre téléphone ou imprimez-la.",
  "Adapt these words": "Adapter ces phrases",
  "Adapt these for {name}": "Adapter ces phrases pour {name}",
  "Ages 2 to 10.": "De 2 à 7 ans.",
  "When you need a little more help": "Quand vous avez besoin d’un peu d’aide",
  "I tried, and it didn’t work.": "J’ai essayé, sans résultat.",
  "Pause instead of repeating the words louder. Show the next step: hold up the pajamas, point to the clothes, or show the shoes by the door. If that doesn’t help, tell Sarah what happened.": "Faites une pause plutôt que de répéter plus fort. Montrez la prochaine étape : le pyjama, les vêtements ou les chaussures près de la porte. Si cela ne suffit pas, racontez à Sarah ce qui s’est passé.",
  "I’m in a rush.": "Je suis pressé(e).",
  "Get the next step ready before you call them over: clothes on the bed, food on the table, shoes by the door. Then use the three phrases on your card.": "Préparez la suite avant d’appeler votre enfant : les vêtements sur le lit, le repas sur la table, les chaussures près de la porte. Puis dites les trois phrases de votre carte.",
  "My mind goes blank.": "J’oublie quoi dire.",
  "That’s what the card is for. Save it now so you can read the words when you need them. You can also find this page from Home under “Just the 3 lines.”": "La carte est là pour ça. Enregistrez-la maintenant pour retrouver les mots au bon moment. Cette page reste accessible dans l’onglet « Les 3 phrases ».",
  "Something else going on?": "Une autre situation vous préoccupe ?",
  "Tell Sarah what happened.": "Racontez à Sarah ce qui s’est passé.",
  "The complete method": "La méthode complète",
  "Read how the three phrases fit into everyday moments, including the times things don’t go smoothly.": "Découvrez comment utiliser les trois phrases au quotidien, même dans les moments difficiles.",
  "Open the book": "Ouvrir le livre",
  "Home": "Accueil",
  "Phrases": "Les 3 phrases",
  "Sarah": "Sarah",
  "Books": "Livres",
  "Profile": "Profil",
  "Main navigation": "Navigation principale",
  "Parenting Made Easy": "Des mots pour le quotidien",
  "© 2026 Obedience Code": "© 2026 La Méthode des 3 Phrases",
  "Go to profile": "Ouvrir le profil",
  "Loading your profile...": "Chargement de votre profil…",
  "This only takes a moment.": "Encore un instant.",
  "If this takes longer than usual, try again in a moment or contact support.": "Si le chargement dure, réessayez dans un instant ou contactez l’assistance.",
  "Install the app": "Ajouter à l’écran d’accueil",
  "Close": "Fermer",
  "I’ve installed it": "C’est ajouté",
  "A new version is ready.": "Une nouvelle version est disponible.",
  "Refresh": "Actualiser",
  "Dismiss": "Fermer",
  "Something went wrong": "Un problème est survenu",
  "Sorry, an unexpected error occurred. Try reloading the page or go back to the home page.": "Une erreur inattendue est survenue. Rechargez la page ou revenez à l’accueil.",
  "Try Again": "Réessayer",
  "Go to Home": "Revenir à l’accueil",
  "Hi! I need help with Obedience Code": "Bonjour, j’ai besoin d’aide avec La Méthode des 3 Phrases.",
  "Parenting made easier": "Des mots pour le quotidien",
  "Tap the ": "Touchez le bouton ",
  " or ": " ou ",
  " button next to the web address at the bottom of the screen.": " à côté de l’adresse, en bas de l’écran.",
  "Tap ": "Touchez ",
  "Share": "Partager",
  ". (On older iPhones, the Share button is already at the bottom.)": ". (Sur les anciens iPhone, le bouton de partage est déjà en bas.)",
  "View More": "Plus",
  ", then ": ", puis ",
  "Add to Home Screen": "Sur l’écran d’accueil",
  "Add": "Ajouter",
  " at the top right.": " en haut à droite.",
  " button next to the web address.": " à côté de l’adresse.",
  " if you don’t see the next option.": " si l’option suivante n’apparaît pas.",
  " menu in the top-right corner.": " en haut à droite.",
  "Install app": "Installer l’application",
  "Add to Home screen": "Ajouter à l’écran d’accueil",
  "Install": "Installer",
  " to confirm.": " pour confirmer.",
  "Look for the install icon in the address bar.": "Repérez l’icône d’installation dans la barre d’adresse.",
  "Click ": "Cliquez sur ",
  "Then open the new Obedience Code icon and sign in once with the same email. After that, it stays signed in.": "Ouvrez ensuite la nouvelle icône de La Méthode des 3 Phrases et connectez-vous avec la même adresse e-mail. Votre session restera ouverte.",
  "We couldn't save your profile. Please try again.": "Impossible d’enregistrer votre profil. Veuillez réessayer.",
  "Retrying...": "Nouvelle tentative...",
  "Retry": "Réessayer",
  "Add Child": "Ajouter un enfant",
  "Get Started": "Commencer",
  "Continue": "Continuer",
  "Add the name and tap the age to continue.": "Indiquez le prénom et touchez l’âge pour continuer.",
  "Add the name to continue.": "Indiquez le prénom pour continuer.",
  "Tap the age to continue.": "Touchez l’âge pour continuer.",
  "Go back": "Retour",
  "Step {step} of {total}": "Étape {step} sur {total}",
  "What happened that made you look for help now?": "Qu’est-ce qui vous amène à chercher de l’aide maintenant ?",
  "Sarah will start right there, with what to say next time.": "Sarah partira de cette situation pour vous aider à trouver quoi dire la prochaine fois.",
  "Or tell us in your own words": "Ou racontez-le avec vos mots",
  "What happened?": "Que s’est-il passé ?",
  "How often are you with {name}?": "À quelle fréquence êtes-vous avec {name} ?",
  "the child": "l’enfant",
  "Advice for someone who isn't there every day is different. Sarah will know.": "Les conseils sont différents si vous n’êtes pas là chaque jour. Sarah en tiendra compte.",
  "What have you tried that didn't work?": "Qu’avez-vous déjà essayé sans succès ?",
  "So Sarah doesn't suggest it again.": "Pour que Sarah ne vous le propose pas à nouveau.",
  "Skip for now": "Passer pour le moment",
  "I am a...": "Je suis...",
  "What should we call you?": "Comment vous appelez-vous ?",
  "Your first name": "Votre prénom",
  "Father": "Père",
  "Mother": "Mère",
  "Grandmother": "Grand-mère",
  "Grandfather": "Grand-père",
  "Caregiver": "Personne qui garde l’enfant",
  "Other": "Autre",
  "And how old are you?": "Et quel âge avez-vous ?",
  "So Sarah's advice fits your day. Optional.": "Pour adapter les conseils de Sarah à votre quotidien. Facultatif.",
  "Under 45": "Moins de 45 ans",
  "45 to 54": "45 à 54 ans",
  "55 to 64": "55 à 64 ans",
  "65 to 74": "65 à 74 ans",
  "75 or older": "75 ans ou plus",
  "Prefer not to say": "Je préfère ne pas répondre",
  "Tell us about your child": "Parlez-nous de votre enfant",
  "Child's name": "Prénom de l’enfant",
  "e.g. Emma": "Ex. : Emma",
  "How old is {name}?": "Quel âge a {name} ?",
  "your child": "votre enfant",
  "Under 1": "Moins d’un an",
  "Pick as many as you like.": "Vous pouvez choisir plusieurs réponses.",
  "Turning off the TV or tablet": "Éteindre la télévision ou la tablette",
  "Bedtime": "Le coucher",
  "When I say no": "Quand je dis non",
  "When I ask and they ignore me": "Quand je demande et qu’on m’ignore",
  "Brothers and sisters fighting": "Les disputes entre frères et sœurs",
  "Getting out the door in the morning": "Partir à l’heure le matin",
  "Mealtime": "Les repas",
  "Leaving the park or someone's house": "Quitter le parc ou une visite chez quelqu’un",
  "Hitting or biting": "Les coups ou les morsures",
  "I'm raising them": "C’est moi qui l’élève",
  "They live with me part of the time": "L’enfant vit chez moi une partie du temps",
  "A few days a week while the parents work": "Quelques jours par semaine, pendant que les parents travaillent",
  "Weekends and visits": "Les week-ends et lors de visites",
  "From far away (phone, FaceTime)": "À distance, par téléphone ou en visio",
  "Asking nicely again and again": "Demander gentiment, encore et encore",
  "Warnings and timers": "Prévenir à l’avance et utiliser un minuteur",
  "Taking away the tablet or toys": "Confisquer la tablette ou les jouets",
  "Time out": "Mettre au coin",
  "Giving choices": "Proposer des choix",
  "Raising my voice": "Hausser le ton",
  "Treats or rewards": "Proposer des friandises ou des récompenses",
  "Nothing yet": "Rien pour le moment",
  "What would you like help with?": "Sur quels sujets souhaitez-vous de l’aide ?",
  "Common focus areas for {age}s, select all that apply": "Difficultés fréquentes chez les {age}. Choisissez celles qui vous concernent.",
  "baby": "bébés",
  "toddler": "tout-petits",
  "preschooler": "enfants de maternelle",
  "school age": "enfants d’âge scolaire",
  "big kid": "plus grands",
  "Select all that apply to your situation": "Choisissez toutes les réponses qui vous concernent",
  "Tip: You can select multiple areas": "Vous pouvez choisir plusieurs sujets",
  "Sleep & Night Wakings": "Sommeil et réveils nocturnes",
  "Feeding Challenges": "Difficultés à s’alimenter",
  "Crying & Soothing": "Pleurs et apaisement",
  "Developmental Milestones": "Étapes du développement",
  "Bonding & Attachment": "Lien et attachement",
  "Tantrums & Big Emotions": "Colères et émotions fortes",
  "Not Listening": "L’enfant n’écoute pas",
  "Sleep Struggles": "Difficultés de sommeil",
  "Picky Eating": "Refus de certains aliments",
  "Separation Anxiety": "Angoisse de séparation",
  "Tantrums & Meltdowns": "Colères et crises",
  "Bedtime Battles": "Conflits au coucher",
  "Morning Routine": "Routine du matin",
  "Sharing & Taking Turns": "Partager et attendre son tour",
  "Screen Time Battles": "Conflits autour des écrans",
  "Homework Struggles": "Difficultés avec les devoirs",
  "Sibling Conflicts": "Conflits entre frères et sœurs",
  "Talking Back": "Réponses insolentes",
  "Phone & Screen Time": "Téléphone et temps d’écran",
  "Attitude & Eye-Rolling": "Opposition et regards exaspérés",
  "Homework Resistance": "Refus de faire les devoirs",
  "Following House Rules": "Respect des règles à la maison",
  "Communication Breakdown": "Difficultés de communication",
  "Reading {name}'s profile": "Lecture du profil de {name}",
  "Reviewing your challenges": "Vos difficultés sont prises en compte",
  "Preparing personalized advice": "Préparation de conseils personnalisés",
  "Sarah is reviewing your profile": "Sarah prépare votre espace",
  "Preparing personalized guidance for you": "Préparation de votre accompagnement personnalisé",
  "Oops! Something went wrong": "Un problème est survenu",
  "We encountered an error while processing your quiz. Don't worry, your data is safe.": "Un problème est survenu pendant le questionnaire. Veuillez réessayer.",
  "Go Home": "Retour à l’accueil",
  "If the problem persists, please contact support.": "Si le problème persiste, contactez l’assistance.",
  "Name is too short (minimum 2 characters)": "Le prénom est trop court (2 caractères minimum)",
  "Name is too long (maximum 50 characters)": "Le prénom est trop long (50 caractères maximum)",
  "Invalid characters. Use only letters, spaces, hyphens, and apostrophes": "Utilisez uniquement des lettres, des espaces, des traits d’union et des apostrophes",
  "Please enter your child's actual name": "Veuillez indiquer le vrai prénom de votre enfant",
  "Please enter only ONE child's name. To add a sibling, finish this profile first, then use \"Add another child\" on the dashboard.": "Indiquez le prénom d’un seul enfant. Vous pourrez ajouter un autre enfant après avoir terminé ce profil.",
  "Please select at least one goal": "Veuillez choisir au moins un objectif",
  "Please select a duration": "Veuillez choisir une durée",
  "Invalid name": "Prénom non valide",
  "Please select an age group": "Veuillez choisir une tranche d’âge",
  "Please select why you are here": "Veuillez indiquer ce qui vous amène",
  "Invalid goals": "Objectifs non valides",
  "Invalid duration": "Durée non valide",
  "User not authenticated": "Veuillez vous connecter",
  "Please sign in to save your profile.": "Connectez-vous pour enregistrer votre profil.",
  "A profile with the name \"{name}\" already exists.": "Un profil au nom de « {name} » existe déjà.",
  "Profile for {name} saved successfully!": "Le profil de {name} a bien été enregistré !",
  "Failed to save profile": "Impossible d’enregistrer le profil. Veuillez réessayer.",
  "We couldn't save your answers. Please try again.": "Impossible d’enregistrer vos réponses. Veuillez réessayer.",
  "User ID not available": "Votre session n’est plus disponible. Veuillez vous reconnecter.",
  "We couldn't finish saving your quiz. Please sign in and try again.": "Impossible de terminer l’enregistrement du questionnaire. Reconnectez-vous et réessayez.",
  "Failed to mark quiz as completed": "Impossible de terminer le questionnaire. Veuillez réessayer.",
  "Something went wrong saving your quiz. Please try again.": "Un problème est survenu lors de l’enregistrement du questionnaire. Veuillez réessayer.",
  "See you soon!": "À bientôt !",
  "Family": "Famille",
  "We encountered an unexpected error. Don't worry, your data is safe.": "Une erreur inattendue est survenue. Veuillez réessayer.",
  "If this problem persists, please contact our support team.": "Si le problème persiste, veuillez contacter notre équipe de support.",
  "Parent": "Parent",
  "Your account": "Votre compte",
  "Member": "Membre",
  "My children": "Mes enfants",
  "Settings": "Réglages",
  "Dark Mode": "Mode sombre",
  "Help": "Aide",
  "Live Support": "Contacter le support",
  "Send Feedback": "Donner votre avis",
  "Terms of Service": "Conditions d’utilisation",
  "Privacy Policy": "Politique de confidentialité",
  "The app": "Votre espace",
  "Reload the app": "Recharger votre espace",
  "Reloading...": "Rechargement…",
  "Refreshing app...": "Actualisation…",
  "Log Out": "Se déconnecter",
  "Version {version}.{build} • Obedience Code": "Version {version}.{build} • La Méthode des 3 Phrases",
  "We could not load your profile. Please try again.": "Impossible de charger votre profil. Veuillez réessayer.",
  "Please choose a photo.": "Veuillez choisir une photo.",
  "This photo is too large. Please choose another one.": "Cette photo est trop volumineuse. Veuillez en choisir une autre.",
  "Photo saved": "Photo enregistrée",
  "We could not save your photo. Please try again.": "Impossible d’enregistrer votre photo. Veuillez réessayer.",
  "Back to the default picture": "Photo par défaut rétablie",
  "We could not change your picture. Please try again.": "Impossible de modifier votre photo. Veuillez réessayer.",
  "You must be signed in to edit your profile": "Connectez-vous pour modifier votre profil.",
  "Please type your first name": "Veuillez saisir votre prénom.",
  "Saved": "Enregistré",
  "We could not save. Please try again.": "Impossible d’enregistrer. Veuillez réessayer.",
  "Edit Profile": "Modifier le profil",
  "Saving your photo…": "Enregistrement de votre photo…",
  "Change photo": "Changer la photo",
  "Add your photo": "Ajouter votre photo",
  "Use the default picture": "Utiliser la photo par défaut",
  "First name": "Prénom",
  "Last name": "Nom",
  "(optional)": "(facultatif)",
  "Saving…": "Enregistrement…",
  "Save": "Enregistrer",
  "Choose how you'd like to contact us": "Choisissez comment nous contacter",
  "WhatsApp": "WhatsApp",
  "Send us a message": "Envoyez-nous un message",
  "Email": "E-mail",
  "sarah@codeofobedience.com · Replies within 24 hours": "support@codeofobedience.com",
  "Active child updated": "Enfant sélectionné",
  "Name is required": "Veuillez saisir un prénom.",
  "Age must be between 1 and 18": "L’âge doit être compris entre 1 et 18 ans.",
  "Profile updated": "Profil mis à jour",
  "Failed to save changes": "Impossible d’enregistrer les modifications. Veuillez réessayer.",
  "Profile removed": "Profil supprimé",
  "Failed to remove profile": "Impossible de supprimer le profil. Veuillez réessayer.",
  "Photo uploaded": "Photo ajoutée",
  "Failed to upload photo": "Impossible d’ajouter la photo. Veuillez réessayer.",
  "My Family": "Mes enfants",
  "Name": "Prénom",
  "Age": "Âge",
  "1 – 18 years": "1 à 18 ans",
  "Save Changes": "Enregistrer les modifications",
  "Remove Profile": "Supprimer le profil",
  "Remove this profile?": "Supprimer ce profil ?",
  "This will remove {name}'s profile and all personalized recommendations. This can't be undone.": "Le profil de {name} et toutes les recommandations personnalisées seront supprimés. Cette action est irréversible.",
  "Cancel": "Annuler",
  "Remove": "Supprimer",
  "No children yet": "Aucun enfant pour le moment",
  "Add your first child to get personalized strategies and content.": "Ajoutez votre premier enfant pour recevoir des conseils personnalisés.",
  "Set Active": "Sélectionner",
  "Active": "Sélectionné",
  "Add Another Child": "Ajouter un autre enfant",
  "{age} year old": "{age} an",
  "{age} years old": "{age} ans",
  "INTENSE": "INTENSE",
  "DISTRACTED": "DISTRAIT",
  "DEFIANT": "OPPOSANT",
  "Explorer": "Explorateur",
  "Sensitive": "Sensible",
  "Leader": "Meneur",
  "Thinker": "Réfléchi",
  "Creative": "Créatif",
  "Today": "Aujourd’hui",
  "Yesterday": "Hier",
  "Hey {name}. What's {childName} into right now that's tripping you up the most?": "Bonjour{name}. Qu’est-ce qui vous met le plus en difficulté avec {childName} en ce moment ?",
  "{name}, hey. When you think about {childName} this week, what's the one moment you wish had gone different?": "Bonjour{name}. Cette semaine avec {childName}, quel moment auriez-vous aimé vivre autrement ?",
  "Hey {name}. Tell me about {childName}, what's the thing you keep running into?": "Bonjour{name}. Parlez-moi de {childName}. Quelle difficulté revient souvent ?",
  "{name}. Give me the messiest moment with {childName} lately, I'll tell you what's underneath it.": "Bonjour{name}. Racontez-moi un moment difficile récent avec {childName}. Regardons ce qui a pu se passer.",
  "Hey {name}. Which kid is on your mind right now, and what's the moment that's tripping you up?": "Bonjour{name}. De quel enfant souhaitez-vous parler ? Quel moment vous met en difficulté ?",
  "{name}, hey. Tell me which one of the kids you're stuck on and the scene that just happened.": "Bonjour{name}. Dites-moi de quel enfant il s’agit et racontez-moi ce qui vient de se passer.",
  "Hey {name}. Which kid wants help today, and what went down?": "Bonjour{name}. Avec quel enfant avez-vous besoin d’aide aujourd’hui ? Que s’est-il passé ?",
  "Hey {name}, I'm Sarah. What's the moment in your day you keep dreading?": "Bonjour{name}, je suis Sarah. Quel moment de la journée appréhendez-vous le plus ?",
  "{name}, I'm Sarah. Tell me what's messy right now. I'll give you the exact words.": "Bonjour{name}, je suis Sarah. Racontez-moi ce qui est difficile en ce moment. Je vous proposerai des mots concrets.",
  "Hey {name}. I'm Sarah. What's happening that made you open the app tonight?": "Bonjour{name}. Je suis Sarah. Qu’est-ce qui vous amène ici aujourd’hui ?",
  "My kid is having a tantrum": "Mon enfant fait une crise",
  "Bedtime is a nightmare tonight": "Le coucher est très difficile ce soir",
  "Mealtime is a battle": "Les repas tournent au conflit",
  "My kid won't get off the screen": "Mon enfant refuse d’arrêter les écrans",
  "My kid won't listen to anything I say": "Mon enfant n’écoute rien de ce que je dis",
  "My kid keeps hitting": "Mon enfant n’arrête pas de taper",
  "We're having a meltdown in public": "Mon enfant fait une crise en public",
  "Morning routine is chaos": "Les matins sont chaotiques",
  "I'm dealing with {context}": "J’ai des difficultés avec cette situation : {context}",
  "Your parenting coach": "Votre assistante IA pour le quotidien en famille",
  "Sarah is an artificial intelligence assistant. She does not replace a doctor or psychologist.": "Sarah est une assistante d’intelligence artificielle. Elle ne remplace pas un médecin ni un psychologue.",
  "We couldn’t load your conversation with Sarah. Your messages are safe.": "Votre conversation avec Sarah n’a pas pu être chargée. Vos messages sont conservés.",
  "New reply from Sarah": "Nouvelle réponse de Sarah",
  "Your message to Sarah": "Votre message à Sarah",
  "Send": "Envoyer",
  "1 year old": "1 an",
  "Select child": "Choisir un enfant",
  "Talking about": "Nous parlons de",
  "Unnamed": "Prénom non renseigné",
  "Sarah is writing": "Sarah vous répond",
  "{name} added.": "Le profil de {name} a été ajouté.",
  "Couldn't save. Try again in a moment.": "L’enregistrement a échoué. Réessayez dans un instant.",
  ", {age} year old": ", {age} an,",
  ", {age} years old": ", {age} ans,",
  "Confirm new child": "Confirmer un nouvel enfant",
  "Quick check: is ": "Pour vérifier : ",
  " one of your kids?": " est bien l’un de vos enfants ?",
  "No": "Non",
  "Yes, add this child": "Oui, ajouter cet enfant",
  "Yes, add": "Oui, ajouter",
  "Didn't quite fit": "Peu adapté à ma situation",
  "Too long or confusing": "Trop long ou peu clair",
  "Not what I asked": "Ne répond pas à ma question",
  "Something else": "Autre chose",
  "Noted. Try it and tell me how it goes.": "C’est noté. Essayez et dites-moi comment cela se passe.",
  "Great. Put it into play tonight.": "Très bien. Vous pouvez essayer ce soir.",
  "Glad it landed. Let me know what happens.": "Tant mieux si cela vous aide. Dites-moi ce que cela donne.",
  "Got it. I'll adjust.": "C’est noté. J’en tiendrai compte.",
  "Thanks for the nudge. Noted.": "Merci de me l’avoir signalé. C’est noté.",
  "Got it. I'll do better next time.": "C’est noté. Je tâcherai de mieux vous répondre.",
  "That didn't save. Please tap it again.": "Votre avis n’a pas été enregistré. Réessayez.",
  "Helpful?": "Cela vous aide ?",
  "Yes": "Oui",
  "Thanks. Anything else?": "Merci. Autre chose à préciser ?",
  "What was off? (optional)": "Qu’est-ce qui ne convenait pas ? (facultatif)",
  "Tell me what was off": "Dites-moi ce qui ne convenait pas",
  "What was off": "Ce qui ne convenait pas",
  "Saving...": "Enregistrement…",
  "Not now": "Pas maintenant",
  "Couldn't send your message. Please try again.": "Votre message n’a pas pu être envoyé. Réessayez.",
  "Sarah is taking longer than usual. Your message was saved, and her reply will show up here. You can also send it again.": "Sarah met plus de temps que d’habitude. Votre message a été enregistré. Sa réponse s’affichera ici. Vous pouvez aussi renvoyer votre message.",
  "Sarah couldn't respond right now. Please try again.": "Sarah n’a pas pu vous répondre pour le moment. Réessayez."
};
